module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1163.138bd275.png";